// import aboutImg from "../../assets/images/jb-architect-about.jpg"

import maximized_space from "../../assets/images/Maximized_Space.webp"
import Natural_Light from "../../assets/images/Natural_Light.webp"
import Realistic_Execution from "../../assets/images/Realistic_Execution.webp"
import Friendly_Approach from "../../assets/images/Friendly_Approach.webp"

import arch_design from "../images/blueprint.png"
import space_plan from "../images/space_plan.png"
import structural_coordination from "../images/organization-structure.png"
import interior_design from "../images/interior-design.png"
import solution from "../images/solution.png"
import consultant from "../images/conversation.png"

import interiorCarouselImg from "../../assets/images/jb-posters/interior.jpg"
import exteriorCarouselImg from "../../assets/images/jb-posters/exterior.jpg"
import planningCarouselImg from "../../assets/images/jb-posters/planning.jpg"
import consultentCarouselImg from "../../assets/images/jb-posters/consultent.jpg"



import panoImg1 from "../../assets/images/360_image/Commercial/360_1.jpg"
import panoImg2 from "../../assets/images/360_image/Commercial/360bfinal.jpg"
import panoImg3 from "../../assets/images/360_image/Commercial/Ladies_area_360.jpg" 
import panoImg4 from "../../assets/images/360_image/Residential/360_Final.jpg"
import panoImg5 from "../../assets/images/360_image/Residential/bed_hq.jpg"
import panoImg6 from "../../assets/images/360_image/Residential/cupboard_hq.jpg"
import panoImg7 from "../../assets/images/360_image/Residential/fb_over_all_image.jpg"
import panoImg8 from "../../assets/images/360_image/Residential/living_360.jpg"
import ProductCarousel from "../../components/ProductCarousel";
export const carouselData =[
        {
          "id": 1,
          "image":"https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/images/carousel/Construction Turnkey copy.jpg",
          "title": "Slide 1",
          "description": "This is the description for Slide 1."
        },
        {
          "id": 2,
          "image":"https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/images/carousel/end to end design copy.jpg",
          "title": "Slide 2",
          "description": "This is the description for Slide 2."
        },
        {
          "id": 3,
          "image":"https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/images/carousel/Interior Design.jpg",
          "title": "Slide 3",
          "description": "This is the description for Slide 3."
        },
        {
          "id": 4,
          "image":"https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/images/carousel/Interior Turnkey copy.jpg",
          "title": "Slide 4",
          "description": "This is the description for Slide 4."
        },
        // {
        //   "id": 5,
        //   "image":"https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/images/Home_Slider/Construction Turnkey copy.jpg",
        //   "title": "Slide 5",
        //   "description": "This is the description for Slide 5."
        // },
        // {
        //   "id": 6,
        //   "image":"https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/images/Home_Slider/end to end design copy.jpg",
        //   "title": "Slide 6",
        //   "description": "This is the description for Slide 6."
        // }
      ]

      
export const whatWeDo = [
  {
    id:1,
    name:"Architectural Design",
    img:arch_design,
    content:"Crafting innovative, functional, and aesthetically pleasing designs tailored to your needs."
  },
  {
    id:2,
    name:"Space Planning",
    img:space_plan,
    content:"Maximizing efficiency to create comfortable and practical living or working spaces."
  },
  {
    id:3,
    name:"Structural Coordination",
    img:structural_coordination,
    content:"Collaborating with structural engineers to ensure seamless integration with our architectural designs."
  },
  {
    id:4,
    name:"Interior Design",
    img:interior_design,
    content:"Designing stylish, comfortable, and personalized interiors that enhance your lifestyle."
  },
  {
    id:5,
    name:"Sustainable Solutions",
    img:solution,
    content:"Incorporating eco-friendly and energy-efficient designs for a greener future."
  },
  {
    id:6,
    name:"Project Consultation",
    img:consultant,
    content:"Guiding you through every step, from concept to completion, with expert advice."
  },
]
      
export const whyChooseUs = [
  {
    id:1,
    name:"Maximized Space",
    img:maximized_space,
    content:"We design spaces with efficiency in mind, ensuring that every square foot is used effectively without compromising comfort or aesthetics. Whether it's a small home or a large commercial project, we make the best use of available space. "
  },
  {
    id:2,
    name:"Natural Light & Airflow",
    img:Natural_Light,
    content:"Our designs prioritize natural lighting and airflow, reducing the need for artificial lighting and mechanical ventilation. This not only enhances comfort but also promotes a healthier living environment."
  },
  {
    id:3,
    name:"Realistic Execution",
    img:Realistic_Execution,
    content:" What we design is what you get! Our planning and execution are so precise that the final built structure closely matches the proposed design, minimizing deviations and ensuring client satisfaction."
  },
  {
    id:4,
    name:"Friendly Approach",
    img:Friendly_Approach,
    content:`We believe in a smooth and transparent working relationship with our clients. From initial discussions to project completion, we maintain open communication, listen to your needs, and provide professional guidance with a personal touch.`
  },
]

export const vrImages = [
  {
    name:"Test0",
    img:"https://raw.githubusercontent.com/Azitech-global/jb-architects-engineers-images/refs/heads/main/images/Service/End_to_end_design/360_Interior/360_fn.jpg"
  }, 
  {
    name:"Test1",
    img:panoImg1
  }, 
  {
    name:"Test2",
    img:panoImg2
  },
  {
    name:"Test1",
    img:panoImg3
  }, 
  {
    name:"Test2",
    img:panoImg4
  },
  {
    name:"Test1",
    img:panoImg5
  }, 
  {
    name:"Test2",
    img:panoImg6
  },
  {
    name:"Test1",
    img:panoImg7
  }, 
  {
    name:"Test2",
    img:panoImg8
  },
]
